import { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Tooltip, IconButton, Tabs, Tab, CircularProgress } from '@mui/material';
import { ArrowBack, Replay, PersonOutlineOutlined, DescriptionOutlined, FileDownloadOutlined, ShareOutlined } from '@mui/icons-material';
import useTicket from './useTicket';
import useUpdate from './useUpdate';
import { config } from '../../../services/config';
import TicketShareModal from "../../../components/modales/TicketShareModal";
import { downloadTicketPDF } from "../../../components/perfil/Compras/api";
import NotDesign from '../../../assets/design-not-available.png';
import ImagenSegura from '../../../components/ImagenSegura';

const apiOrigin = config.URL_API;

const Ticket = () => {
  const history = useHistory();
  const param = useParams();
  const [t] = useTranslation("global");
  const { ticket } = useTicket();
  // console.log(param.idticket);
  const { fetch } = useUpdate({ idevento: param.id, idticket: param.idticket });
  const routeImage = `${apiOrigin}/eventos/tickets/${param.idticket}/img`;

  const imageStyle = {
    width: window.innerWidth > 880 ? "400px" : "100px"
  }
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [downloading, setDownloading] = useState(false);
  const [shareModalOpen, setShareModalOpen] = useState(false);

  const handleDownload = async () => {
    if (!ticket?.id) return;
    try {
      setDownloading(true);
      const pdfBlob = await downloadTicketPDF(ticket.id);
      const url = window.URL.createObjectURL(pdfBlob);

      const eventoNombre = ticket?.Evento?.evento || 'evento';
      const ticketTipo = ticket?.tarifa?.concepto || 'ticket';
      const fileName = `${eventoNombre.replace(/\s+/g, '_')}_${ticketTipo.replace(/\s+/g, '_')}_${ticket.id}.pdf`;

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading ticket PDF:", error);
      alert("Error al descargar el ticket. Por favor, inténtalo de nuevo más tarde.");
    } finally {
      setDownloading(false);
    }
  };

  const handleShare = () => {
    setShareModalOpen(true);
  };
  const handleCloseShareModal = () => {
    setShareModalOpen(false);
  };

  return (
    <div style={{ backgroundColor: "#F9FAFB", height: " 100%" }}
    >
      <div className="d-flex flex-row justify-content-between" style={{ backgroundColor: "white", borderTop: "1px solid #E4E4E7", borderBottom: "1px solid #E4E4E7", padding: "10px", }}>
        <button type="button" onClick={() => history.push(`/eventos/${param.id}/tickets`)}>
          <ArrowBack />
        </button>
        <div className='d-flex flex-row align-items-center gap-4'>
          <p className='mb-0' style={{ fontWeight: "600" }}>{ticket?.Evento?.evento}</p>
          <span style={{ borderRight: "1px solid #e4e4e7", height: "100%" }}></span>
          <p className='mb-0'>Ticket ID: <span style={{ fontWeight: "600" }}>{ticket?.id}</span> </p>
        </div>
      </div>

      <div style={{ backgroundColor: "white", padding: "10px 40px", margin: "30px", borderRadius: "10px", border: "1px solid #e4e4e7", }}>
        <div className='d-flex flex-row justify-content-between align-items-center my-3'>
          <p className='mb-0' style={{ fontSize: "18px", color: "#5656FF", fontWeight: "600" }}>Vista previa del ticket</p>
          <div className='d-flex flex-row gap-2'>
            <button
              type="button"
              onClick={handleDownload}
              style={{
                /* border: "1px solid #5656FF", */
                color: "#5656FF",
                borderRadius: "50%",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: window.innerWidth <= 576 ? "13px" : "14px",
                opacity: downloading ? 0.7 : 1
              }}
              disabled={downloading}
            >
              {downloading ? (
                <>
                  <CircularProgress size={18} sx={{ color: '#5656FF' }} />
                </>
              ) : (
                <>
                  <Tooltip title="Descargar ticket" arrow>
                    <IconButton><FileDownloadOutlined /> </IconButton>
                  </Tooltip>

                </>
              )}
            </button>
            <button
              type="button"
              onClick={handleShare}
              style={{
                /* backgroundColor: "#5656FF", */
                color: "#5656FF",
                borderRadius: "50%",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: window.innerWidth <= 576 ? "13px" : "14px",
              }}
            >
              <Tooltip title="Compartir ticket" arrow>
                <IconButton><ShareOutlined /></IconButton>
              </Tooltip>
            </button>
            <button type="button" onClick={fetch}>
              <Tooltip title="Actualizar diseño del ticket" arrow>
                <IconButton>
                  <Replay />
                </IconButton>
              </Tooltip>
            </button>
          </div>
        </div>

        <div style={{ borderRadius: "10px", border: "1px solid #e4e4e7", }}>
          <div className='d-flex justify-content-center'>
            <ImagenSegura src={routeImage} alt='Imagen del ticket' style={imageStyle} onError={(e) => {
              e.target.onerror = null;
              e.target.src = NotDesign;
            }}/>
          </div>
        </div>
        <div style={{ borderTop: "1px solid #e4e4e7", marginTop: "40px", paddingTop: "40px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            centered
            variant="fullWidth"
            sx={{
              backgroundColor: "#F4F4F5",
              borderRadius: "10px",
              alignItems: "center",
              padding: "5px",
              justifyContent: "center",
              "& .MuiTabs-indicator": {
                display: "none",
              },
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: "500",
                color: "#6c757d",
                backgroundColor: "transpared",
                borderRadius: "5px",
                transition: "all 0.3s ease",
                minHeight: "20px",
                width: "100%"
              },
              "& .Mui-selected": {
                color: "black !important",
                backgroundColor: "white",
                padding: "4px 10px 4px",
                fontWeight: "600",
                width: "100%"

              },
            }}
          >
            <Tab label="Detalles del Ticket" />
            <Tab label="Información Adicional" />
          </Tabs>
          <div>
            {value === 0 &&
              <div>
                <div>
                  <div className="d-flex flex-row gap-2" style={{ padding: "25px 0 10px", borderBottom: "1px solid #e4e4e7" }}>
                    <PersonOutlineOutlined style={{ color: "#5656FF", }} />
                    <p style={{ fontSize: "18px", color: "#5656FF", fontWeight: "600", marginBottom: "0" }}>Información del Comprador</p>
                  </div>
                  <div style={{ marginTop: "20px", gap: "50%" }} className='d-flex flex-row '>
                    <div className='d-flex flex-column'>
                      <p className='mb-0' style={{ fontWeight: "400", color: " #6B7280", lineHeight: "14px", fontSize: "14px" }}>
                        Nombre
                      </p>
                      <p className='mb-0' style={{ fontWeight: "500" }}>{ticket?.nombre}</p>
                      <div style={{ marginTop: "15px" }}>
                        <p className='mb-0' style={{ fontWeight: "400", color: " #6B7280", lineHeight: "14px", fontSize: "14px" }}>
                          Tarifa
                        </p>
                        <p className='mb-0' style={{ fontWeight: "500" }}>{ticket?.tarifa?.concepto}</p>
                      </div>
                    </div>
                    <div className='d-flex flex-column'>
                      <p className='mb-0' style={{ fontWeight: "400", color: " #6B7280", lineHeight: "14px", fontSize: "14px" }}>
                        Apellido
                      </p>
                      <p className='mb-0' style={{ fontWeight: "500" }}>{ticket?.apellido}</p>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: "20px", padding: "20px 0 10px", borderTop: "1px solid #e4e4e7" }}>
                  <p className='mb-0' style={{ fontWeight: "300", color: " #6B7280", lineHeight: "14px", fontSize: "14px" }}>Este ticket es personal e intransferible.</p>
                </div>
              </div>}
            {value === 1 && <div>
              <div>
                <div className="d-flex flex-row gap-2" style={{ padding: "25px 0 10px", borderBottom: "1px solid #e4e4e7" }}>
                  <DescriptionOutlined style={{ color: "#5656FF", }} />
                  <p style={{ fontSize: "18px", color: "#5656FF", fontWeight: "600", marginBottom: "0" }}>Información adicional</p>
                </div>
                {ticket?.informacion_adicional?.length > 0 ? (
                  <div className="row mt-4">
                    {ticket?.informacion_adicional?.map((info, index) => (
                      <div key={info.id} className={`col-12 ${index % 2 === 0 && ticket.informacion_adicional.length > 1 ? 'col-md-6' : 'col-md-12'}`}>
                        <div className="mb-4">
                          <p style={{
                            fontSize: "14px",
                            color: "#6B7280",
                            fontWeight: "500",
                            marginBottom: "8px"
                          }}>
                            {info.informacion_adicional?.informacion_adicional}
                          </p>
                          <p style={{
                            fontSize: "16px",
                            color: "#111827",
                            fontWeight: "600",
                            marginBottom: "0"
                          }}>
                            {info.respuesta}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="mt-4 text-center">
                    <p style={{ color: "#6B7280", fontSize: "14px", fontWeight: "500" }}>
                      No hay información adicional disponible para este ticket.
                    </p>
                  </div>
                )}
              </div>
            </div>}
          </div>
        </div>
      </div>
      {shareModalOpen && (
        <TicketShareModal
          open={shareModalOpen}
          setShareModalOpen={setShareModalOpen}
          onClose={handleCloseShareModal}
          ticketId={ticket?.id}
          eventoNombre={ticket?.Evento?.evento || 'Evento'}
          ticketTipo={ticket?.tarifa?.concepto || 'Ticket'}
          ticketName={ticket?.nombre}
        />
      )}
    </div>
  );
};

export default Ticket;